export default defineNuxtPlugin(()=>{
    
})